<template>
  <div id="app">
    <template v-if="signedIn">
      <template v-if="isAdviser">
        <HeaderItem :signedIn="true" :isAdviser="true" :isStaff="false" />
      </template>
      <template v-else-if="isStaff">
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="true" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="false" />
      </template>
    </template>
    <template v-else>
      <template v-if="isAdviser">
        <HeaderItem :signedIn="false" :isAdviser="true" :isStaff="false" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="false" :isAdviser="false" :isStaff="false" />
      </template>
    </template>
    <main class="common-main">
      <!-- 認証済みの時はメインの画面を表示 -->
      <template v-if="signedIn">
        <template v-if="isAdmin">
          <h2 class="common-title">アドバイザー一覧【開示先限定】</h2>
          <div class="item" style="color:red">
            個人情報が含まれます。取り扱いに注意してください。<br>
            ローカル環境にダウンロードして作業が必要な場合は、必ず作業後に速やかに削除してください。
          </div>
          <button class="item" @click="downloadCSV">Download CSV</button>
          <h3 class="common-title">合計：{{totalCount}}件</h3>
          <dl class="item">
            <template v-if="userData">
              <ul v-for="user in userData" :key="user.id" class="text-box box-green">
                <li><img width="75" :src="user.iconUrl" alt="" /></li>
                <li><b>アカウント種別</b>： {{user.type}}</li>
                <li><b>ID</b>： {{user.id}}</li>
                <li><b>メールアドレス</b>： {{user.mailAddress}}</li>
                <li><b>表示名</b>： {{user.displayName}}</li>
                <li><b>姓</b>： {{user.lastName}}</li>
                <li><b>名</b>： {{user.firstName}}</li>
                <!--<li><b>続柄</b>： {{user.relationship}}</li>--><!-- user only -->
                <li><b>生年月日</b>： {{user.birthDate}}</li>
                <li><b>性別</b>： {{user.gender}}</li>
                <li><b>日本在住</b>： {{user.isLiveInJapan}}</li>
                <li><b>郵便番号</b>： {{user.postalCode}}</li>
                <li><b>がん種</b>： {{user.cancerType}}</li>
                <!--<li><b>ステージ</b>： {{user.cancerStage}}</li>--><!-- user only -->
                <!--<li><b>がんと診断された年月日</b>： {{user.diagnosedDate}}</li>--><!-- user only -->
                <!--<li><b>がんが発見されたきっかけ</b>： {{user.diagnosedReason}}</li>--><!-- user only -->
                <!--<li><b>現在かかっている病院・診療科</b>： {{user.hospitalName}}</li>--><!-- user only -->
                <!--<li><b>現在の状況</b>： {{user.curativeStatus}}</li>--><!-- user only -->
                <!--<li><b>罹患歴</b>： {{user.cancerHistory}}</li>--><!-- user only -->
                <li><b>罹患歴のあるがん種</b>： {{user.diagnosedCancerType}}</li><!-- adviser only-->
                <li><b>専門分野</b>： {{user.specialty}}</li><!-- adviser only-->
                <li><b>所属</b>： {{user.affiliation}}</li><!-- adviser only-->
                <li><b>肩書</b>： {{user.businessTitle}}</li><!-- adviser only-->
                <li><b>資格</b>： {{user.licentiate}}</li><!-- adviser only-->
                <li><b>プロフィール</b>： {{user.profile}}</li><!-- adviser only-->
                <li><b>会員情報登録日</b>： {{user.createAt | date}}</li>
                <li><b>会員情報最終更新日</b>： {{user.updateAt | date}}</li>
              </ul>
            </template>
            <template v-else>
              <div class="loading"></div>
            </template>
          </dl>
        </template>
        <template v-else-if="isStaff">
          <dl class="item">
            管理者権限が必要です
          </dl>
        </template>
        <template v-else>
        </template>
      </template>

      <!-- 認証していない時はログイン画面を表示 -->
      <template v-else>
        <LoginItem :createButton="false" />
      </template>
    </main>
    <FooterItem :contactUrl="contactUrl" :hiddenFooterFixedButton="true" />
  </div>
</template>

<script>
import { API, Auth, Storage, graphqlOperation, Analytics, Logger } from 'aws-amplify'
//import { AmplifyEventBus } from 'aws-amplify-vue'
import HeaderItem from './Header'
import FooterItem from './Footer'
import LoginItem from './Login'
import { onAuthUIStateChange } from '@aws-amplify/ui-components';

import { listStaffAllowListsBySpecificUser } from './graphql/queries'
import { listUsers } from "./graphql/queries"
import { createErrorLog } from "./graphql/mutations"

const logger = new Logger('AdminAdviserList');
//window.LOG_LEVEL = 'VERBOSE'
//logger.info('info bar');
//logger.debug('debug bar');
//logger.warn('warn bar');
//logger.error('error bar');
Analytics.autoTrack('pageView', {
  enable: true,
  eventName: 'pageView',
  type: 'multiPageApp',
  provider: 'AWSPinpoint',
  getUrl: () => {
    return window.location.origin + window.location.pathname;
  }
});

export default {
  name: 'AdminAdviserList',
  components: {
    HeaderItem,
    FooterItem,
    LoginItem
  },
  data() {
    return {
      authState: undefined,
      unsubscribeAuth: undefined,
      id: '',
      mailaddress: '',
      signedIn: false,
      isStaff: false,
      isAdmin: false,
      contactUrl: '',
      userData: null,
      totalCount: '-'
    }
  },
  
  filters: {
    date: function (value) {
      var valueDate = new Date(value)
      var valueFormat = 'YYYY-MM-DD HH:mm'
      valueFormat = valueFormat.replace(/YYYY/, valueDate.getFullYear())
      
      if (valueDate.getMonth() + 1 < 10) {
        valueFormat = valueFormat.replace(/MM/, '0' + (valueDate.getMonth() + 1))
      } else {
        valueFormat = valueFormat.replace(/MM/, valueDate.getMonth() + 1)
      }
      
      if (valueDate.getDate() < 10) {
        valueFormat = valueFormat.replace(/DD/, '0' + valueDate.getDate())
      } else {
        valueFormat = valueFormat.replace(/DD/, valueDate.getDate())
      }

      if (valueDate.getHours() < 10) {
        valueFormat = valueFormat.replace(/HH/, '0' + valueDate.getHours())
      } else {
        valueFormat = valueFormat.replace(/HH/, valueDate.getHours())
      }

      if (valueDate.getMinutes() < 10) {
        valueFormat = valueFormat.replace(/mm/, '0' + valueDate.getMinutes())
      } else {
        valueFormat = valueFormat.replace(/mm/, valueDate.getMinutes())
      }
      
      return valueFormat
    }
  },
  
  created () {
    this.refresh()
  },

  methods: {
    refresh () {
      Storage.list('')
        .then(result => 
          this.s3Data = JSON.parse(JSON.stringify(result))
        )
        .catch(err => {
          logger.error(err)
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'AdminAdviserList',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              errorType: 'Image List : Storage.list',
              errorNumber: 'AdminAdviserList-01',
              errorMessage: err
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'AdminAdviserList',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            errorType: 'Image List : Storage.list',
            errorNumber: 'AdminAdviserList-01',
            errorMessage: err,
            addUser: 'system',
            createAt: new Date()
          }
          API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          //alert(err)
        })
    },

    download(key, num, type, i, identityId) {
      Storage.get(key, { level: 'protected', identityId: identityId })
        .then(result => {
          //console.log(result)
          
          if (!key) {
            result = null
          }
          if (type === 'icon' && result && this.userData[i] !== undefined) {
            var tmpData = this.userData[i]
            tmpData.iconUrl = result
            this.userData.splice(i, 1, tmpData)
            return result
          } else {
            /*
            if (num === 1) {
              this.uploadedImage1 = result
            } else if (num === 2) {
              this.uploadedImage2 = result
            } else if (num === 3) {
              this.uploadedImage3 = result
            }
            */
          }
        })
        .catch(err => {
          logger.error(err)
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'AdminAdviserList',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              counselingTopicsId: this.counselingId,
              errorType: 'Image download : Storage.get',
              errorNumber: 'AdminAdviserList-02',
              errorMessage: err
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'AdminAdviserList',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            errorType: 'Image download : Storage.get',
            errorNumber: 'AdminAdviserList-02',
            errorMessage: err,
            addUser: 'system',
            createAt: new Date()
          }
          API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          //alert(err)
          //alert("画像の取得処理に失敗しました")
        })
    },
    
    downloadCSV() {
      let confirmResult = confirm('個人情報を含むファイルをダウンロードしますか？\n情報漏えいリスクがあるので、作業後は「ゴミ箱」含め、速やかにファイルを削除してください')
      if (confirmResult) {
        let csv = ''
        let headerLabel = ''
        let hasHeaderLabel = false
        this.userData.forEach(el => {
          var line = ''
          for (let key in el) {
            line += el[key] + ','
            if (!hasHeaderLabel) {
              headerLabel += key + ','
            }
          }
          if (!hasHeaderLabel) {
            headerLabel = '\ufeff' + headerLabel.slice(0, -1) + '\n'
            csv = headerLabel + csv
            hasHeaderLabel = true
          }
          line = line.slice(0, -1) + '\n'
          csv += line
        })
        var blob = new Blob([ csv ], { "type" : "csv/plain" });
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = '【開示先限定】アドバイザー一覧.csv'
        link.click()
      }
    }
  },

  beforeDestroy() {
    this.unsubscribeAuth();
  },

  async beforeCreate() {
    this.unsubscribeAuth = onAuthUIStateChange(async (authState, authData) => {
      this.authState = authState;
      this.user = authData;
      if (authState === 'signedin') {
        let cognitoUser = await Auth.currentAuthenticatedUser()
        this.signedIn = true
        this.id = cognitoUser.username

        // TODO: ここで hasUserData の確認処理をキックし、リロードの要不要を判定
        location.reload(1)
      } else if (authState === 'signedout') {
        // ログアウト前の情報を破棄
        this.$destroy()
        location.reload(1)
      } else {
        this.signedIn = false
      }
    });
    
    // Auth.currentAuthenticatedUser()でユーザ情報を取得する。
    // 取得できなければ認証ステータスをfalseに設定する
    try {
      let cognitoUser = await Auth.currentAuthenticatedUser()
      this.signedIn = true
      this.id = cognitoUser.username
      this.mailaddress = cognitoUser.attributes.email

      let currentCredentials = await Auth.currentCredentials()
      this.identityId = currentCredentials.identityId
    } catch (err) {
      this.signedIn = false
    }

    // 運営アカウントか判定
    try {
      let staffAllowData = await API.graphql(
        graphqlOperation(listStaffAllowListsBySpecificUser, {
          mailAddress: this.mailaddress,
          limit: 1
        })
      )
      if (
        staffAllowData.data.listStaffAllowListsBySpecificUser.items[0].mailAddress ===
        this.mailaddress
      ) {
        // 運営モード
        this.isStaff = true
        this.contactUrl = ''

        if (staffAllowData.data.listStaffAllowListsBySpecificUser.items[0].isAdmin) {
          this.isAdmin = true
        } else {
          this.isAdmin = false
        }
      } else {
        this.isStaff = false
        this.isAdmin = false
        this.contactUrl = ''
        this.$router.push({ path: 'dashboard' })
      }
    } catch (err) {
      this.isStaff = false
      this.isAdmin = false
      this.contactUrl = ''
      this.$router.push({ path: '../dashboard' })    
    }

    // 情報取得
    if (this.isAdmin) {
      try {
        this.userData = await API.graphql(graphqlOperation(
          listUsers, {limit: 99999}
        ))
        this.userData = this.userData.data.listUsers.items

        this.userData.sort (function(a, b) {
          if (new Date(a.createAt) > new Date(b.createAt)) {
            return -1
          } else {
            return 1
          }
        })

        var tmpUserData = []
        for (var key in this.userData) {
          if (this.userData[key].type == 'adviser') {
            // がん種JSON整形
            this.userData[key].cancerType = JSON.parse(this.userData[key].cancerType).join('、')
            
            // アイコン取得
            if (this.userData[key].iconImageKey) {
              this.download(this.userData[key].iconImageKey, null, 'icon', key, this.userData[key].iconUploadedIdentityId)
            } else {
              // 登録がなければデフォルトアイコン
              this.userData[key].iconUrl = this.userData[key].iconDefaultUrl
            }

            tmpUserData.push(this.userData[key])
          }
        }
        this.userData = tmpUserData
        this.totalCount = this.userData.length
      } catch (err) {
        this.userData = []
      }
    }
    
    Analytics.record({
      name: 'accessLog', 
      attributes: { 
        page: 'AdminAdviserList',
        url: window.location.origin + window.location.pathname,
        userid: this.id,
        userType: ''
      }
    });

  }
}
</script>
<style>
</style>
<style src="./assets/style.css" />
